import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-back-dialog',
  templateUrl: './back-dialog.component.html',
  styleUrls: ['./back-dialog.component.css'],
})
export class BackDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<BackDialogComponent>) {}

  ngOnInit(): void {}
}
